export class UserInfo {
    firstName: string = "";
    lastName: string = "";
    email: string = "";    
    name: string = "";
    companyName: string = "";
    isAuthenticated: boolean = false;
}
